module.exports = __webpack_public_path__ + "static/img/鐵花棧.f816d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/鐵花棧.png?20181011
// module id = YtJr
// module chunks = 1